import "./orden_venta.css";
export { default as Crear } from "./Crear";
export { default as Listado } from "./Listado";
export { default as Detalle } from "./Detalle";
//export { default as ListadoEntregaOV } from "./EntregaOrdenVenta/Listado";
//export { default as EntregaOV } from "./EntregaOrdenVenta/EntregaOV";
//export { default as VisualizacionOV } from "./EntregaOrdenVenta/Visualizacion";
